import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import React, {useState, useEffect} from "react";
import { useInView } from "react-intersection-observer"; //Serve per caricare le immagini solo quando entrano nel "viewport"
import "./ImgCard.css";                                                    


//PROPS RICEVUTE
//titolo: usato per comporre il nome del file immagine (Scinze.jpg, ecc).
//descrizione: viene mostrata sotto il titolo
//onClick: callback da invocare quando la card viene cliccata
//pathImmagine: override per il percorso immagine personalizzato
//sezione: l'oggetto da passare alla funzione "onClick" quando clicco

const ImgCard = ({titolo, descrizione, onClick, pathImmagine, sezione, tipo, slug })=>{
    const [imgURL, setImgURL] = useState(null);
    //ref serve a osservare quando il componente entra nel viewport
    //inView diventra "true" quando almeno il 20% del componente è visibile
    //triggerOnce: true lo fa solo una volta. Ottimo per evitare richieste multiple
    const {ref, inView} = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    //Carico solo se è visibile e se non ho già caricato l'immagine
    //Il nome del file si basa su "pathImmagine" o "titolo"
    //Se fallisce, logga un warning, non blocca nulla
    useEffect(()=>{
        if(inView && !imgURL){
            const storage = getStorage();
            // const nomeFile = pathImmagine || (tipo === "articolo" ? `immagini/articoli/${titolo}.jpg` : `immagini/${titolo}.jpg`)
            let nomeFile;
            if (pathImmagine && pathImmagine.trim() !== ""){
                //Caso 1: DB ha immaginePath => uso direttamente quello
                nomeFile = pathImmagine;
                console.log(`immagine estrapolata da pathImmagine ${nomeFile}`)
            }
            else if (slug){
                //Caso 2: DB ha slug => costruisco percorso da Slug
                nomeFile = tipo === "articolo"
                ? `immagini/articoli/${slug}.jpg`
                : `immagini/sezioni/${slug}.jpg`;
                console.log(`immagine estrapolata da slug ${nomeFile}`)
            }
            else{
                //Caso 3: fallback legacy => uso il titolo
                nomeFile = tipo === "articolo"
                ? `immagini/articoli/${titolo}.jpg`
                : `immagini/${titolo}.jpg`;
                console.log(`immagine estrapolata da titolo ${nomeFile}`)
            }
            const imgRef = storageRef(storage, nomeFile);
            getDownloadURL(imgRef)
            .then((url) => setImgURL(url))
            .catch(()=> console.warn(`Immagine non trovata per ${nomeFile}`));
        }
    },[inView, imgURL, titolo, pathImmagine, tipo, slug])


  //RENDERING DEL COMPONENTE
  //Quando clicco invio l'intera sezione al componente padre 
  //ref={ref} serve a "useView"
  //Mostro l'immagine solo se "imgURL" è disponibile
  
  return(

    <div className ="sezione" onClick={(()=>onClick(sezione))} ref={ref} style={{cursor: "pointer"}}>
            <h3 className="titleCard">{titolo}</h3>
            <p>{descrizione}</p>
            {imgURL && (
                <img
                    src={imgURL}
                    alt={titolo}
                    loading="lazy"
                    style={{ width: "100%", height: "180px", objectFit:"cover", marginTop: "20px", borderRadius: "8px"}}
                ></img>
            )}
             {tipo !=="articolo" && (
            <p className="articleCount">
                {sezione.articoli
                    ? `${sezione.articoli.length} articoli`
                    : "Nessun articolo"
                }
            </p>
            )}
    </div>

  );  
};

export default ImgCard;